_ = require("lodash")

MAX_PLAYERS = 4

preparePlayers = (players) ->
  clonePlayers = _.cloneDeep(players)
  _.times MAX_PLAYERS - clonePlayers.length, ->
    clonePlayers.push
      name: ''
      player_hdcp: undefined
      scores: []
  clonePlayers

escape = (name) ->
  replacements = [
    [/&/g, '&amp;']
    [/</g, '&lt;']
    [/"/g, '&quot;']
    [/'/g, '&#039;']
  ]
  for r in replacements
    name = name.replace r[0], r[1]
  name

escapeSelect = (name) ->
  replacements = [
    [/&amp;/g, '&']
    [/&lt;/g, '<']
    [/&quot;/g, '"']
    [/&#039;/g, "'"]
  ]
  for r in replacements
    name = name.replace r[0], r[1]
  name

class SelectPlayersCtrl
  constructor: (@$scope, @PlayerAPIService, @flash, @$filter, @ScoreDataHolderService, @AccordionStateHolderService) ->
    @isSavingPlayers = false
    @_playersWatch = @$scope.$watch (=> @ScoreDataHolderService.players), (players) =>
      @players = preparePlayers(players || [@ScoreDataHolderService.ownerPlayer])
      @_clearFrom()
      #Unbinding watch because, we just need it when init
      @_playersWatch()

  searchPlayers: (value) ->
    @PlayerAPIService.search(value).then (data) ->
      for n in data.players
        n.name = escape(n.name)
      data.players

  selectPlayer: (item, index) ->
    item.name = escapeSelect(item.name)
    @players[index] = item

  validateDuplicatePlayer: (value, $index) ->
    _.chain @players
      .reject (p, index) -> index is $index
      .every (p) -> p.name isnt value
      .value()

  _updatePlayers: (responsePlayers) ->
    _.forEach responsePlayers, (p1) =>
      existPlayer = _.find @players, (p2) -> p1.name is p2.name
      if existPlayer
        existPlayer.id = p1.id
        existPlayer.scores = []
        existPlayer.scores_extra = []

  _clearFrom: ->
    return unless @form
    @form.clearForm()

  _processPlayers: ->
    #This function is used for keep scores of user
    filterPlayers = _.filter @players, (p) -> p.id and p.name
    filterPlayers = _.map filterPlayers, (p, index) ->
      _.merge {}, p,
        scores_extra: p.scores_extra
    storedPlayers = @ScoreDataHolderService.players
    return filterPlayers unless storedPlayers
    _.map filterPlayers, (p, index) ->
      sp = storedPlayers[index]
      _.merge {}, p,
        scores: if sp then sp.scores else p.scores
        scores_extra: if sp then sp.scores_extra else p.scores_extra

  savePlayers: ->
    @isSavingPlayers = true
    @PlayerAPIService.savePlayers(@players).then (resp) =>
      @PlayerAPIService.clearOwnerCache()
      @_updatePlayers(resp.data.players)
      @_clearFrom()
      @ScoreDataHolderService.players = @_processPlayers()
      @AccordionStateHolderService.goToStep(3)
    .catch (resp) =>
      if resp.data?.code is 'error.name_already_taken'
        @flash.error @$filter('translate')('NAME_DUPLICATED')
      else
        @flash.error @$filter('translate')('API_ERROR')
    .finally =>
      @isSavingPlayers = false

SelectPlayersCtrl.$inject = [
  '$scope'
  'PlayerAPIService'
  'flash'
  '$filter'
  'ScoreDataHolderService'
  'AccordionStateHolderService'
]

module.exports = SelectPlayersCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/select-players/select-players-controller.coffee